import React from "react";

export const TemplatesModal = ({ templates, setTemplates, onSave, onClose }) => {
  const addTpl = () => setTemplates([...templates, { id: `t-${Date.now()}`, name: "Novo template", body: "" }]);
  const removeTpl = (id) => setTemplates(templates.filter((t) => t.id !== id));
  const update = (id, field, val) => setTemplates(templates.map((t) => t.id === id ? { ...t, [field]: val } : t));

  return (
    <div className="fixed inset-0 bg-slate-900/60 z-50 flex items-center justify-center p-6" onClick={onClose}>
      <div className="bg-white rounded-xl border border-slate-200 max-w-3xl w-full max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="p-6 border-b border-slate-200 flex items-center justify-between">
          <div>
            <h3 className="font-display font-bold text-xl text-[#0B2B62]">Templates de WhatsApp</h3>
            <p className="text-xs text-slate-500 mt-0.5">Variáveis: <code className="font-mono">{'{{protocol}} {{patient_name}} {{patient_age}} {{city}} {{substance}} {{risk_level}} {{consultor_name}} {{clinic_name}} {{pdf_url}}'}</code></p>
          </div>
          <button onClick={onClose} className="text-slate-500 hover:text-slate-800 text-xl">×</button>
        </div>
        <div className="p-6 space-y-4">
          {templates.map((t) => (
            <div key={t.id} className="border border-slate-200 rounded-lg p-4 space-y-2">
              <div className="flex items-center gap-2">
                <input value={t.name} onChange={(e) => update(t.id, "name", e.target.value)}
                  className="flex-1 px-2.5 py-1.5 border border-slate-300 rounded-md text-sm outline-none focus:ring-2 focus:ring-[#0B2B62]" />
                <button onClick={() => removeTpl(t.id)} className="text-red-600 hover:text-red-700 text-xs">Remover</button>
              </div>
              <textarea value={t.body} onChange={(e) => update(t.id, "body", e.target.value)} rows={7}
                className="w-full px-2.5 py-2 border border-slate-300 rounded-md text-sm font-mono outline-none focus:ring-2 focus:ring-[#0B2B62]" />
            </div>
          ))}
          <button onClick={addTpl} className="text-sm text-[#0B2B62] hover:underline font-semibold">+ Adicionar template</button>
        </div>
        <div className="p-6 border-t border-slate-200 flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 border border-slate-300 rounded-md text-sm">Cancelar</button>
          <button data-testid="save-templates" onClick={onSave} className="px-4 py-2 bg-[#0B2B62] text-white rounded-md text-sm font-semibold">Salvar</button>
        </div>
      </div>
    </div>
  );
};
